import React from 'react'
import { t } from 'i18next'
import { Row, Col } from 'antd'

import LogInOutBtn from '@Core/Components/Shared/LogInOutBtn'
import useBreakPoint from 'CustomHook/useBreakPoint'
import kymQrCode from '@Assets/kym_qr_code.png'
import googlePlayBadgeLogo from '@Assets/google-play-badge-logo.webp'

import {
  Copyright,
  StyledLink,
  StyledaTag,
  FooterIcon,
  FooterRow,
} from './style'

const Footer = () => {
  const { xs, sm, md, lg } = useBreakPoint()
  let spanValue = 6
  if (xs) spanValue = 24
  if (sm) spanValue = 12
  if (md) spanValue = 6
  return (
    <>
      <FooterRow gutter={[0, 8]} xs={xs} sm={sm}>
        <Col span={xs ? 24 : md ? 18 : 19}>
          <Row gutter={[0, 8]}>
            <Col span={spanValue}>
              <StyledLink to={'/search'}>{t('skip_to_content')}</StyledLink>
            </Col>
            <Col span={spanValue}>
              <StyledLink to={'/terms-and-conditions'}>
                {t('terms_and_conditions')}
              </StyledLink>
            </Col>
            <Col span={spanValue}>
              <StyledLink to={'/privacy-policy'}>
                {t('privacy_policy')}
              </StyledLink>
            </Col>
            <Col span={spanValue}>
              <StyledLink to={'/faqs'}>{t('faqs')}</StyledLink>
            </Col>
            <Col span={spanValue}>
              <StyledLink to={'/disclaimers'}>{t('disclaimers')}</StyledLink>
            </Col>
            <Col span={spanValue}>
              <StyledLink to={'/suggest-missing-brand'}>
                {t('suggest_a_missing_brand')}
              </StyledLink>
            </Col>
            <Col span={spanValue === 3 ? 4 : spanValue}>
              <StyledaTag
                href="https://www.nadaindia.org/en/contactus"
                target="_blank"
              >
                {t('contact_us')}
              </StyledaTag>
            </Col>
            <Col span={spanValue}>
              <LogInOutBtn />
            </Col>
            <Col span={spanValue}>
              <StyledLink to={'/delete-account'}>
                {t('delete_account')}
              </StyledLink>
            </Col>
          </Row>
        </Col>
        <Col span={xs ? 24 : md ? 6 : 5}>
          <FooterIcon lg={lg} xs={xs}>
            <div className="innterImage">
              <a
                href="https://play.google.com/store/apps/details?id=com.nada.doppingapp&hl=en-US&ah=Y2vJnNn1vnJIuKW9LClKYWZcIg4"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="img1"
                  src={googlePlayBadgeLogo}
                  alt="kym_qr_code"
                />
              </a>
            </div>
            <img className="img2" src={kymQrCode} alt="kym_qr_code" />
          </FooterIcon>
        </Col>
      </FooterRow>
      <Row>
        <Col span={24}>
          <Copyright>Copyright 2023. All Rights reserved By NADA </Copyright>
        </Col>
      </Row>
    </>
  )
}

export default Footer
